/*@flow*/
import L from 'leaflet';
import type { DeckPropsT } from '../types';
import { useEffect } from 'react';

export default (props: DeckPropsT<*>) => {
  const { options, owner } = props;

  useEffect(() => {
    const element = L.control.zoom(options);
    owner.addControl(element);
    return () => {
      owner.removeControl(element);
    };
  }, []);
};
